import { ListMenuItem } from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import {
  ContributorBulkCreateMatchesPageState,
  contributorBulkCreateMatchesPageRoute,
} from "../ContributorBulkCreateMatchesPage/ContributorBulkCreateMatchesPage";
import {
  ContributorBulkMergePageState,
  contributorBulkMergePageRoute,
} from "../ContributorBulkMergePage/ContributorBulkMergePage";

export const useContributorListMenuItems = (props: { permission: Permission; selectedIds: number[] }) => {
  const navigate = useNavigate();
  const menuItems: ListMenuItem[] = [];

  if (isAuthorized(props.permission, PermissionAction.Update))
    menuItems.push({
      label: "+ New Time & Effort",
      action: (selectedIds: number[]) =>
        navigate(contributorBulkCreateMatchesPageRoute.getPath(), {
          state: { selectedIds: selectedIds } as ContributorBulkCreateMatchesPageState,
        }),
    });

  if (isAuthorized(Permission.Contributor, PermissionAction.Update)) {
    menuItems.push({
      label: "Merge",
      action: (selectedIds: number[]) =>
        navigate(contributorBulkMergePageRoute.getPath(), {
          state: { selectedIds: selectedIds } as ContributorBulkMergePageState,
        }),
      disabled: props.selectedIds.length < 2,
    });
  }

  return menuItems;
};
